module.exports = __webpack_public_path__ + "img/new-truck-green.9de5724a.svg";